import v19Schema, {
  MigrationTypes as V19Types,
} from "../client/schemaVersions/v19.js";
import v20Schema, {
  MigrationTypes as V20Types,
} from "../client/schemaVersions/v20.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V19Types, V20Types>(
  v19Schema,
  v20Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
